import api from '@/services/api';
import { useMutation } from '@tanstack/react-query';

export enum TaxRegime {
    mei = 'mei',
    simples = 'simples',
    lucroPresumido = 'lucro_presumido',
    lucroReal = 'lucro_real',
}

export type UpdateTaxData = {
    taxRegime?: TaxRegime;
    emitInvoice?: boolean;
    accountingCnpj?: string | null;
    municipalInscription?: string | null;
    stateInscription?: string | null;
    digitalCertificate?: File | null;
    A1DigitalCertificate?: File | null;
    digitalCertificatePassword?: string;
    idTokenNfceProduction?: string;
    cscNfceProduction?: string;
    focusGlobalToken?: string;
    complementaryInformationTaxpayer?: string;
};

export default function useUpdateTaxDataShopmanager() {
    const mutationFn = async (data: FormData) => {
        await api.patch('/shopmanagers/tax-data', data);
    };

    return useMutation({
        mutationFn,
    });
}
